import StarRatings from 'react-star-ratings';

export const StarRatingDisplay = ({
  rating,
  ratingsCount,
  compact = false,
}: {
  rating: number;
  ratingsCount?: number;
  compact?: boolean;
}) => {
  if (!rating) {
    return null;
  }

  if (!compact) {
    return (
      <span className="leader-rating-display d-flex align-items-center gap-1">
        <StarRatings
          rating={rating}
          starHoverColor="goldenrod"
          starRatedColor="gold"
          starDimension="24px"
          starSpacing="2px"
          numberOfStars={5}
        />{' '}
        {rating.toFixed(2)} {ratingsCount ? `(${ratingsCount})` : null}
      </span>
    );
  }
  return (
    <span className="leader-rating-display">
      {' '}
      ⭐️ {rating.toFixed(2)} {ratingsCount ? `(${ratingsCount})` : null}
    </span>
  );
};
